"use strict";

module.exports = {
    "i-services": {
        "404": "404",
        "adresa": "Alamat",
        "advertising": "Iklan",
        "afisha": "Afisha",
        "all": "Semua layanan",
        "api": "API",
        "appmetrica": "AppMetrica",
        "appsearch": "Aplikasi",
        "audience": "Audience",
        "auto": "Mobil",
        "autoru": "auto.ru",
        "avia": "Penerbangan",
        "aziada": "",
        "ba": "Bayan",
        "backapv": "",
        "balance": "Saldo",
        "bar": "Bar",
        "bar-ie": "",
        "bar-ie9": "",
        "bayan": "",
        "blogs": "Blog",
        "books": "Buku",
        "browser": "Browser",
        "calendar": "Kalender",
        "captcha": "",
        "catalogwdgt": "",
        "chrome": "",
        "city": "Kota",
        "cityday": "Hari Perayaan Kota",
        "clickhouse": "ClickHouse",
        "collection": "Koleksi",
        "company": "Perusahaan",
        "contest": "Kontes",
        "delivery": "Pengiriman",
        "desktop": "",
        "direct": "Langsung",
        "direct.market": "Pasar",
        "disk": "Disk",
        "display": "Tampilan",
        "ege": "Ujian Negara Kenaikan Kelas Rusia",
        "expert": "",
        "feedback": "Hubungi kami",
        "feedback2": "Hubungi kami",
        "ff": "",
        "fotki": "Foto",
        "fresh": "Terbaru",
        "games": "Game",
        "geocontext": "",
        "goroda": "",
        "help": "Bantuan",
        "i": "",
        "ie": "",
        "images": "Gambar",
        "images-com": "Gambar",
        "interests": "Minat",
        "internet": "",
        "kassa": "Solusi Pembayaran",
        "keyboard": "",
        "kraski": "",
        "kuda": "Tempat",
        "large": "",
        "legal": "Dokumen legal",
        "lenta": "Umpan",
        "libra": "Perpustakaan",
        "literacy": "",
        "local": "Jaringan Lokal",
        "lost": "",
        "love": "",
        "mail": "Email",
        "maps": "Peta",
        "maps-wiki": "",
        "market": "Pasar",
        "market.advertising": "Pasar",
        "master": "Yandex.Master",
        "metrika": "Metrica",
        "metro": "",
        "mobile": "Seluler",
        "moikrug": "Moi Krug",
        "money": "Uang",
        "museums": "",
        "music": "Musik",
        "music-partner": "",
        "nahodki": "Temuan Saya",
        "nano": "Nano",
        "newhire": "Newhire",
        "news": "Berita",
        "notifications": "Panel pemberitahuan",
        "oauth": "OAuth",
        "online": "Online",
        "openid": "OpenID",
        "opera": "Perangkat Lunak Opera",
        "opinion": "",
        "partners": "Jaringan Periklanan",
        "partnersearch": "",
        "passport": "Paspor",
        "pdd": "Email untuk Domain",
        "peoplesearch": "Pencarian orang",
        "perevod": "Terjemahkan",
        "probki": "",
        "pulse": "",
        "punto": "Pengalih Punto",
        "pvo": "Tanya",
        "rabota": "Pekerjaan",
        "radar": "Radar",
        "ramazan": "",
        "rasp": "Jadwal",
        "realty": "",
        "referats": "",
        "rk": "",
        "root": "Yandex.Olympiad untuk administrator Unix",
        "school": "",
        "search": "Web",
        "server": "Server",
        "shtrafi": "",
        "site": "Pencarian situs",
        "slovari": "Kamus",
        "so": "",
        "social": "",
        "soft": "Program",
        "sport": "Olahraga",
        "sprav": "Direktori",
        "start": "",
        "stat": "",
        "subs": "Langganan",
        "taxi": "Taksi",
        "telephony": "Телефония",
        "terms": "",
        "tests": "",
        "tickets": "Tiket",
        "time": "Yandex.Time",
        "toloka": "Yandex.Toloka",
        "toster": "",
        "translate": "Terjemahkan",
        "tune": "Lagu",
        "tv": "TV",
        "uslugi": "Layanan",
        "video": "Video",
        "video-com": "Video",
        "vno": "ZNO",
        "wdgt": "Widget",
        "weather": "Cuaca",
        "webmaster": "Webmaster",
        "webmaster-api": "API Webmaster",
        "widgets": "Widget",
        "wordstat": "Statistik",
        "wow": "Ya.ru",
        "www": "Web",
        "xmlsearch": "XML",
        "yaca": "Katalog",
        "yamb": "Spanduk Media",
        "zakladki": "Bookmark"
    }
};